import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
}
export function CTAButton({
  href,
  children
}: CTAButtonProps) {
  return <a href={href} className="group inline-flex w-full max-w-xl items-center justify-center gap-2 rounded-lg border-b-4 border-gold-dark bg-gold px-4 py-3 text-center font-display text-base font-extrabold uppercase leading-tight text-forest shadow-lg ring-2 ring-forest/80 transition-[transform,background-color] duration-150 ease-out hover:bg-[#E0B43E] active:translate-y-px sm:px-8 sm:py-4 sm:text-xl" data-id="element-26" data-mp="2kz7npo98lt6q">
      <span data-id="element-27" data-mp="33nupnxw4a2g3">{children}</span>
      <ChevronRightIcon className="hidden h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" strokeWidth={3} aria-hidden="true" data-id="element-28" data-mp="33r8sf78p0do2" />
    </a>;
}